import React, { useRef, useState } from "react"
import { Form, Button, Card, Alert } from "react-bootstrap"
import { useAuth } from "../../contexts/AuthContext"
import { Link, useHistory } from "react-router-dom"
import { FaGoogle } from "react-icons/fa"
import styled from "styled-components"
import { getAuthErrorMessage } from "../../util/authErrors"

const SignupContainer = styled.div`
  max-width: 440px;
  margin: 100px auto 20px;
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    margin-top: 80px;
    padding: 0 16px;
  }
`;

const StyledCard = styled(Card)`
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
`;

export default function Signup() {
  const emailRef = useRef()
  const passwordRef = useRef()
  const passwordConfirmRef = useRef()
  const { signup, signInWithGoogleProvider } = useAuth()
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const [googleLoading, setGoogleLoading] = useState(false)
  const history = useHistory()

  async function handleSubmit(e) {
    e.preventDefault()

    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError("Passwords do not match")
    }

    try {
      setError("")
      setLoading(true)
      await signup(emailRef.current.value, passwordRef.current.value)
      history.push("/user")
    } catch (error) {
      setError(getAuthErrorMessage(error, "We could not create your account. Please try again."))
    }

    setLoading(false)
  }

  async function handleGoogleSignIn() {
    try {
      setError("")
      setGoogleLoading(true)
      await signInWithGoogleProvider()
      history.push("/user")
    } catch (error) {
      setError(getAuthErrorMessage(error, "We could not sign you up with Google."))
      console.error("Google sign-in error:", error)
    }
    setGoogleLoading(false)
  }

  return (
    <SignupContainer>
      <StyledCard>
        <Card.Body>
          <h2 className="text-center mb-3">Sign Up</h2>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group id="email">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" ref={emailRef} required />
            </Form.Group>
            <Form.Group id="password">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" ref={passwordRef} required />
            </Form.Group>
            <Form.Group id="password-confirm">
              <Form.Label>Password Confirmation</Form.Label>
              <Form.Control type="password" ref={passwordConfirmRef} required />
            </Form.Group>
            <Button disabled={loading} className="w-100" type="submit">
              Sign Up
            </Button>
          </Form>
          
          <div className="text-center mt-3 mb-3">
            <span style={{ color: '#6c757d' }}>or</span>
          </div>
          
          <Button 
            disabled={googleLoading || loading} 
            className="w-100" 
            variant="outline-primary"
            onClick={handleGoogleSignIn}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              border: '2px solid #4285f4',
              color: '#4285f4',
              backgroundColor: 'white',
              fontWeight: '500'
            }}
          >
            <FaGoogle size={18} />
            {googleLoading ? 'Signing in...' : 'Sign up with Google'}
          </Button>
        </Card.Body>
      </StyledCard>
      <div className="w-100 text-center mt-2">
        Already have an account? <Link to="/login">Log In</Link>
      </div>
    </SignupContainer>
  )
}
